module.exports = __webpack_public_path__ + "img/Want Smile Sm.e437c8d6.png";